// extracted by mini-css-extract-plugin
export default {"container":"KoinToast_container__4OdPx","content":"KoinToast_content__BUj-d"};